/**
 * @generated SignedSource<<51445aaba4a1e5a41221cfe56abf7869>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifiedAuthenticationModalBodyFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountCreationStepFragment_session" | "InitialStepAuthenticationModalFragment_Session" | "JoinNewClubStepFragment_session" | "VerifyCodeStep_session">;
  readonly " $fragmentType": "VerifiedAuthenticationModalBodyFragment_session";
};
export type VerifiedAuthenticationModalBodyFragment_session$key = {
  readonly " $data"?: VerifiedAuthenticationModalBodyFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"VerifiedAuthenticationModalBodyFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VerifiedAuthenticationModalBodyFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountCreationStepFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinNewClubStepFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VerifyCodeStep_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InitialStepAuthenticationModalFragment_Session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "0613456cc019b852cd6135c7a3c4e146";

export default node;
